module.exports = __webpack_public_path__ + "public/img/Kepuasan Pelanggan untuk Kasir.2afe0326.png";